import { postBeforeOrder, postOrder } from '@/api'
import { Message } from 'element-ui'
import { cloneDeep, isEmpty, get } from 'lodash-es'

const state = {}
const mutations = {}
const actions = {
  async onSubmitYXD({ dispatch, rootGetters }, aliCaptchaId) {
    try {
      /**
       * 这里还要考虑 滑块
       * aliCaptchaId  滑块拉黑接口返回id
       */
      let params = rootGetters.orderForm
      params.isProd = rootGetters.isProd //宽带安装意愿
      if (aliCaptchaId && !aliCaptchaId == '') {
        params.aliCaptchaId = aliCaptchaId
      } else {
        params.aliCaptchaId = ''
      }
      const { status, data, subcode, msg } = await postBeforeOrder(params).catch((err) => {
        return Promise.reject(err)
      })
      if (status == 1) {
        const res = await dispatch(`onSubmitFormal`, data)
        res.type = 2
        return res
      } else {
        return {
          subcode,
          msg,
          params,
          type: 1,
        }
      }
    } catch (error) {
      console.log(error)
      return
    }
  },
  async onSubmitFormal({ dispatch, rootGetters }, applyId) {
    try {
      /**
       * 这里还要考虑 滑块
       */
      let params = rootGetters.orderForm
      params.applyId = applyId
      if (rootGetters.hunanMurmur) {
        params.fingerNum = rootGetters.hunanMurmur
      }

      delete params.aliCaptchaId
      delete params.session
      delete params.sig
      delete params.token

      let newParams = await this.dispatch('ttMiniapp/getAppLet', cloneDeep(params))
      const res = await postOrder(newParams).catch((err) => {
        return Promise.reject(err)
      })
      return res
    } catch (error) {
      console.log(error)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
